import { getStripePurchaseCommonEventParams } from 'modules/purchase/helpers/getStripePurchaseCommonEventParams'

import { IAppState } from 'models/store.model'

export const getStripePurchaseFailedEventParams = (state: IAppState) => {
  const {
    productId,
    stripePriceId,
    trialPeriodPrice,
    currency,
    screenName,
    trialPriceId,
    fullPrice,
    stripeAccountId,
    stripeAccountName,
  } = getStripePurchaseCommonEventParams(state)

  return {
    productId: trialPriceId ? productId : stripePriceId,
    priceDetails: {
      price: fullPrice,
      trial: !!trialPeriodPrice,
      currency,
    },
    screenName,
    stripeAccountId,
    stripeAccountName,
  }
}
